import React, { Fragment, Suspense, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import GridItem from '../../../catalog/GridItem';
import Item from '../../../catalog/Item';
import store, { persistor } from '../../../store';

const List = ({
  prods,
  node,
  categories,
  active = null,
  itemsPerPage = 10,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setTimeout(() => {
      node.style.minHeight = 'auto';
    }, 1000);
  }, []);

  // Reset page when category changes
  useEffect(() => {
    setCurrentPage(1);
  }, [active]);

  // Get active category name
  const activeCategoryName = useMemo(() => {
    if (!active) {
      return '';
    }

    const category = categories.find((cat) => cat.id === active);
    return category ? category.name : '';
  }, [active, categories]);

  const activeCategoryLink = useMemo(() => {
    if (!active) {
      return '';
    }

    const category = categories.find((cat) => cat.id === active);
    return category ? category.link : '';
  }, [active, categories]);

  const filteredProds = prods.filter(
    (prod) => active === null || active.toString() === prod.category.toString(),
  );

  const totalPages = Math.ceil(filteredProds.length / itemsPerPage);

  // Get current items
  const currentItems = filteredProds.slice(0, currentPage * itemsPerPage);

  return (
    <>
      {currentItems.map((prod) => {
        const { id, category } = prod;
        const key = `p_${id}`;
        const activeIdStr = active + '';
        if (active !== null && activeIdStr !== category) {
          return <Fragment key={key}></Fragment>;
        }

        return <Item key={key} prod={prod} viewCmpt={GridItem} />;
      })}

      {/* Show More Button */}
      {currentPage < totalPages && (
        <div className="show-more-container">
          <button
            onClick={() => setCurrentPage((prev) => prev + 1)}
            className="show-more-button"
          >
            Показать еще
          </button>
        </div>
      )}
      {/* Total Items Button */}
      {active && (
        <div className="show-more-container">
          <button
            className="show-more-button"
            onClick={() => (window.location = activeCategoryLink)}
          >
            <span className="category__details">
              {activeCategoryName && `Все товары: ${activeCategoryName}`}
              <a href={activeCategoryLink}>
                <img
                  src="/static/img/icons/Arrow.svg"
                  alt="klavka prodct list all"
                />
              </a>
            </span>
          </button>
        </div>
      )}
    </>
  );
};

const Categories = ({ categories, onClick, active }) => {
  return (
    <div className="facing-cat__link neighbours-mob">
      <ul>
        {categories.map(({ id, name }) => {
          const activeClass = id === active ? 'active' : 'inactive';
          return (
            <li key={id} onClick={() => onClick(id)}>
              <span className={activeClass}>{name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const ListWithCategories = ({ prods, categories, node }) => {
  const firstCtgrId = (categories.length > 0 && categories[0].id) || null;
  const [active, setActive] = useState(firstCtgrId);

  return (
    <>
      <Categories categories={categories} onClick={setActive} active={active} />
      <div className="category__wrap pp-grid">
        <List
          prods={prods}
          node={node}
          active={active}
          categories={categories}
        />
      </div>
    </>
  );
};

export const extraProds = (id, prods) => {
  if (prods.length === 0) {
    return;
  }

  const node = document.getElementById(id);
  const root = ReactDOM.createRoot(node);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <React.StrictMode>
          <Suspense fallback={<></>}>
            <div className="category__wrap pp-grid">
              <List prods={prods} node={node} />
            </div>
          </Suspense>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
  );
};

export const extraProdsWithCategories = (id, prods, categories) => {
  if (prods.length === 0) {
    return;
  }

  const node = document.getElementById(id);
  const root = ReactDOM.createRoot(node);

  root.render(
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <React.StrictMode>
          <Suspense fallback={<></>}>
            <ListWithCategories
              prods={prods}
              categories={categories}
              node={node}
            />
          </Suspense>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
  );
};
